import {useEffect, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {prospectApi} from 'api';
import {Button, ExternalLink, InformationModal} from 'components';
import {APP_LANDING_UPGRADE_URL} from 'constants/app';
import {useApiData} from 'hooks';
import {TRANSLATION_KEYS} from 'locale';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.BILLING.SUBSCRIPTION.UPGRADE_MODAL;

type Props = {
    open: boolean;
    onClose: () => void;
}

export const UpgradePlanModal: React.FC<Props> = ({open, onClose}) => {
    const {t} = useTranslation();

    const {send: getUpgradeToken, data} = useApiData(prospectApi.getUpgradeToken);
    const upgradeUrl = useMemo(() => data?.token ? `${APP_LANDING_UPGRADE_URL}?data=${data.token}` : null, [data]);

    useEffect(() => {
        if (open && !upgradeUrl) {
            getUpgradeToken();
        }
    }, [open, upgradeUrl, getUpgradeToken]);

    return (
        <InformationModal title={t(T_KEYS.TITLE)} open={open} onClose={onClose}>
            {t(T_KEYS.DESCRIPTION)}
            <ExternalLink className='tw-block tw-text-center tw-mt-8' link={upgradeUrl}>
                <Button color='primary'>{t(T_KEYS.BTN_TEXT)}</Button>
            </ExternalLink>
        </InformationModal>
    );
};